const lazyPageComponent = () => import('@/Pages/Ru/PrivacyPolicy.vue');
const lazyPublicOfferComponent = () => import('@/Pages/Ru/PublicOffer.vue');
const lazyAgreementComponent = () => import('@/Pages/Ru/AgreementPage.vue');

export const privacyPolicyRoutes = [
  {
    path: '/privacy-policy',
    pathname: '/privacy-policy',
    name: 'privacy-policy',
    component: lazyPageComponent,
    meta: {
      name: 'privacy-policy',
    },
  },
  {
    path: '/public-offer',
    pathname: '/public-offer',
    name: 'public-offer',
    component: lazyPublicOfferComponent,
    meta: {
      name: 'public-offer',
    },
  },
  {
    path: '/agreement',
    pathname: '/agreement',
    name: 'agreement',
    component: lazyAgreementComponent,
    meta: {
      name: 'agreement',
    },
  },
];
